var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13437 13.125C3.84687 13.125 3.60687 13.0288 3.41437 12.8363C3.22146 12.6433 3.125 12.4031 3.125 12.1156V2.88437C3.125 2.59687 3.22146 2.35688 3.41437 2.16438C3.60687 1.97146 3.84687 1.875 4.13437 1.875H9.0625L11.875 4.6875V12.1156C11.875 12.4031 11.7788 12.6431 11.5863 12.8356C11.3933 13.0285 11.1531 13.125 10.8656 13.125H4.13437ZM8.75 5H11.25L8.75 2.5V5Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.2e64a19c6fc7a42f0eff8f88b6343b31.svg";
export { ForwardRef as ReactComponent };